const SICSEN = {
    C003TiposResoluciones: 'SICSEN/Catalogos/GetTiposResoluciones'
  };
    
  export default SICSEN;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICSEN/catalogos/catalogos.js
// module id = null
// module chunks = 